import { Tag } from 'antd';
import { companyColors, companyOptions } from 'apps/investment/constants';
import {
  fundAccountESignStatusColors,
  fundAccountESignStatusLabels,
  fundAccountStatusColors,
  fundAccountStatusOptions,
} from 'apps/investment/constants/fund-account';
import { fundDistributorsOptions } from 'apps/investment/constants/fund-distributors';
import { DataTableColumnHeader } from 'common/data-table-column-header';
import { FilterFieldConfig } from 'common/dynamic-filter-form';
import { LabelTooltip } from 'common/ui/label-tooltip';
import { dateTimeCell, linkCell } from 'utils/cell-formatter';

export const columnsGenerator = () => [
  {
    accessorKey: 'id',
    header: '',
    cell: ({ getValue }) =>
      linkCell({ getValue, path: '/investment/fund-accounts' }),
  },
  {
    accessorKey: 'created_at',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Created" />
    ),
    cell: dateTimeCell,
  },
  {
    accessorKey: 'trading_code',
    header: 'Account Number',
  },
  {
    accessorKey: 'status',
    header: 'Trạng thái',
    cell: ({ getValue }) => {
      const status = getValue();
      return <Tag color={fundAccountStatusColors[status]}>{status}</Tag>;
    },
  },
  {
    accessorKey: 'sign_contract_status',
    header: 'Trạng thái hđ',

    cell: ({ getValue }) => {
      const value = getValue();
      if (!value) return;
      return (
        <Tag color={fundAccountESignStatusColors[value]}>
          {fundAccountESignStatusLabels[value] || value}
        </Tag>
      );
    },
  },

  {
    accessorKey: 'trading_account_manager',
    header: 'Đại lý',
    cell: ({ getValue }) => {
      const value = getValue();
      return <Tag color={companyColors[value]}>{value}</Tag>;
    },
  },
  {
    accessorKey: 'source',
    header: 'Source',
    cell: ({ getValue }) => {
      const value = getValue();
      return <Tag color={companyColors[value]}>{value}</Tag>;
    },
  },
  {
    accessorKey: 'kyc_status',
    header: (
      <LabelTooltip
        label="Trạng thái KYC"
        tooltipContent="Trạng thái KYC từ đối tác"
      />
    ),
    cell: ({ getValue }) => {
      const value = getValue();
      return <Tag>{value}</Tag>;
    },
  },
  {
    accessorKey: 'user_id',
    header: 'User',
    cell: ({ row }) => {
      return row.original.full_name || row.original.email;
    },
  },
  {
    accessorKey: 'approved_at',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Aprroved" />
    ),
    cell: dateTimeCell,
  },
  {
    accessorKey: 'updated_at',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Updated" />
    ),
    cell: dateTimeCell,
  },
];

export const filterConfig: FilterFieldConfig[] = [
  {
    name: 'status',
    type: 'select',
    label: 'Status',
    placeholder: 'All',
    minWidth: '100px',
    options: fundAccountStatusOptions.map(option => ({
      value: option,
      label: option,
    })),
    defaultValue: 'all',
  },
  {
    name: 'trading_account_manager',
    type: 'select',
    label: 'Trading account manager',
    placeholder: 'All',
    minWidth: '100px',
    options: fundDistributorsOptions,
    defaultValue: 'all',
  },
  {
    name: 'source',
    type: 'select',
    label: 'Source',
    placeholder: 'All',
    minWidth: '100px',
    options: companyOptions,
    defaultValue: 'all',
  },
];
